module.exports = __webpack_public_path__ + "img/inspiration.19ab3c44.png";